/** Canvas counterparts of the existing Arthaus CSS tokens in styles/globals.css. */
export interface GraphTheme {
  background: string
  card: string
  foreground: string
  muted: string
  mutedForeground: string
  border: string
  gold: string
  palette: {
    blue: string
    orange: string
    green: string
    yellow: string
    pink: string
    forest: string
    violet: string
  }
}
export const defaultGraphTheme: GraphTheme = {
  background: '#fafafa',
  card: '#ffffff',
  foreground: '#1f1f1f',
  muted: '#f5f5f5',
  mutedForeground: '#737373',
  border: '#e6e6e6',
  gold: '#f59f0a',
  palette: {
    blue: '#2a78d6',
    orange: '#eb6834',
    green: '#1baf7a',
    yellow: '#eda100',
    pink: '#e87ba4',
    forest: '#008300',
    violet: '#6250d6',
  },
}
export function mixColor(a: string, b: string, amount: number) {
  return (
    '#' +
    [1, 3, 5]
      .map((offset) =>
        Math.round(
          parseInt(a.slice(offset, offset + 2), 16) * (1 - amount) +
            parseInt(b.slice(offset, offset + 2), 16) * amount
        )
          .toString(16)
          .padStart(2, '0')
      )
      .join('')
  )
}
function hslHex(value: string, fallback: string) {
  const parts = value.match(/^\s*([\d.]+)\s+([\d.]+)%\s+([\d.]+)%\s*$/)
  if (!parts) return fallback
  const h = Number(parts[1]) / 360,
    s = Number(parts[2]) / 100,
    l = Number(parts[3]) / 100
  const a = s * Math.min(l, 1 - l)
  return (
    '#' +
    [0, 8, 4]
      .map((n) => {
        const k = (n + h * 12) % 12
        return Math.round(255 * (l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1))))
          .toString(16)
          .padStart(2, '0')
      })
      .join('')
  )
}
export function readGraphTheme(element: Element): GraphTheme {
  const css = getComputedStyle(element)
  const hsl = (key: string, fallback: string) => hslHex(css.getPropertyValue(key).trim(), fallback)
  const hex = (key: string, fallback: string) => {
    const value = css.getPropertyValue(key).trim()
    return /^#[\da-f]{6}$/i.test(value) ? value : fallback
  }
  return {
    background: hsl('--background', defaultGraphTheme.background),
    card: hsl('--card', defaultGraphTheme.card),
    foreground: hsl('--foreground', defaultGraphTheme.foreground),
    muted: hsl('--muted', defaultGraphTheme.muted),
    mutedForeground: hsl('--muted-foreground', defaultGraphTheme.mutedForeground),
    border: hsl('--border', defaultGraphTheme.border),
    gold: hsl('--arthaus-gold', defaultGraphTheme.gold),
    palette: {
      blue: hex('--viz-p1', defaultGraphTheme.palette.blue),
      orange: hex('--viz-p2', defaultGraphTheme.palette.orange),
      green: hex('--viz-p3', defaultGraphTheme.palette.green),
      yellow: hex('--viz-p4', defaultGraphTheme.palette.yellow),
      pink: hex('--viz-p5', defaultGraphTheme.palette.pink),
      forest: hex('--viz-p6', defaultGraphTheme.palette.forest),
      violet: hex('--viz-sessions', defaultGraphTheme.palette.violet),
    },
  }
}
